import { createFragment, delegatedEvent } from '../lib/lib';
import { MAGIC_NUMBERS } from './constants';

export function init() {
  const filters = document.querySelector('#recipe-filter-form');
  if (!filters) {
    return;
  }

  addFilterEvents();
}

const FILTER_FORM_ID = 'recipe-filter-form';
const getFilterFormElement = () => document.getElementById(FILTER_FORM_ID);

const getFilterOperatorElements = () =>
  document.querySelectorAll('.p-filter-operator');

const getSortOrderElement = () => document.getElementById('sort');

const getSelectedFilters = () =>
  document.querySelectorAll('.p-filter__checkbox:checked');

const getFilterCheckboxes = () =>
  document.querySelectorAll('.p-filter__checkbox');

const getClearAllFiltersButton = () =>
  document.querySelector('.p-filter__clear');

const getActiveFilterSection = () =>
  document.querySelector('.js-recipe-active-filters');

const createFilterButton = (text, id) =>
  `<button class="mr-2 mb-2 p-filter__input p-filter__active" data-filter-id="${id}">
      <span class="mr-2 px-1 p-filter__active-text">${text}</span>
      <span class="p-filter__remove"></span>
  </button>`;

const removeStyleToFilterLabel = e => {
  getFilterCheckboxes().forEach(e => {
    if (e.checked === false) {
      e.nextElementSibling.classList.remove('p-label__active');
    }
  });
};

const listitemToggle = e => {
  if (e.currentTarget.classList.contains('sub-level')) {
    var childUl2 = e.currentTarget.parentElement.nextElementSibling;
    var childIcon2 = e.currentTarget.querySelector('[class*=icon]');

    childUl2.classList.toggle('hidden');
    childUl2.classList.toggle('open-section');
    childIcon2.classList.toggle('open');
  } else {
    var childUl = e.currentTarget.nextElementSibling;
    var childIcon = e.currentTarget.querySelector('[class*=icon]');

    childUl.classList.toggle('hidden');
    childUl.classList.toggle('open-section');
    e.currentTarget.classList.toggle('open-section');
    if (childIcon) {
      e.currentTarget.classList.toggle('closed');
      childIcon.classList.toggle('open');
    }
  }
};

const clearFilters = ev => {
  getSelectedFilters().forEach(input => {
    input.checked = false;
    ev.preventDefault();
    input.nextElementSibling.classList.remove('p-label__active');
  });
  onFormChange();
  getFilterOperatorElements().forEach(e => e.classList.add('hidden'));
};

const onFormChange = e => {
  let filters = [];
  removeStyleToFilterLabel();
  getSelectedFilters().forEach(e => {
    e.nextElementSibling.classList.add('p-label__active');
    e.addEventListener('click', function(ev) {
      ev.stopPropagation();
    });
    filters.push({
      key: e.value,
      value: e.id,
    });
  });
  var sortValString = '&sortorder=' + getSortOrderElement().value;
  filterRecipes(
    filters.map(obj => obj.key),
    sortValString,
  );
};

const onFilterButton = (element, e) => {
  e.preventDefault();
  const filterCheckBox = document.getElementById(
    'filter-' + element.getAttribute('data-filter-id'),
  );

  if (filterCheckBox) {
    filterCheckBox.click();
    filterCheckBox.nextElementSibling.classList.remove('p-label__active');
  }
};

const addFilterEvents = () => {
  const listItems = document.querySelectorAll('.js-filter-item');
  getClearAllFiltersButton().addEventListener('click', clearFilters);
  getFilterFormElement().addEventListener('change', onFormChange);
  getSortOrderElement().addEventListener('change', onFormChange);
  listItems.forEach(item => {
    item.addEventListener('click', listitemToggle);
  });

  delegatedEvent(getActiveFilterSection())(
    'click',
    '.p-filter__active',
    onFilterButton,
  );
};

const renderFilterButtons = () => {
  const buttons = [...getSelectedFilters()].reduce((ret, input) => {
    const { value, id } = input;
    const text = document.querySelector(`[for=${id}]`).textContent.trim();

    return ret + createFilterButton(text, value);
  }, '');

  const buttonContainer = getActiveFilterSection();
  buttonContainer.querySelectorAll('.p-filter__active').forEach(child => {
    child.parentElement.removeChild(child);
  });

  const fragment = createFragment(buttons);
  buttonContainer.querySelector('.p-label').after(fragment);

  if (buttons !== '') {
    getFilterOperatorElements().forEach(e => e.classList.remove('hidden'));
  } else {
    getFilterOperatorElements().forEach(e => e.classList.add('hidden'));
  }
};

const filterRecipes = (filters, sortString) => {
  var url = window.location.href;

  url =
    url[url.length - 1] === '/'
      ? url + 'FilterRecipes/'
      : url + '/FilterRecipes/';

  fetch(url + '?catidstring=' + filters.join(',') + sortString, {
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json; charset=UTF-8',
      'X-Requested-With': 'XMLHttpRequest',
    },
    method: 'POST',
  })
    .then(res => res.text())
    .then(function(html) {
      document.querySelector('.js-recipe-results').innerHTML = html;
    })
    .catch(function(err) {
      console.log('Fetch Error :-S', err);
    });
  renderFilterButtons();
};
